<template>
  <main class="d-flex flex-column w-100" style="gap: 20px">
    <section class="d-flex align-items-center">
      <div
        v-for="item in items"
        :key="item.index"
        :class="{ 'flex-grow-1': item?.index < items.length }"
      >
        <Transition name="step">
          <section v-if="item?.index" class="wrapper-class">
            <span
              class="step-item"
              :class="{
                'active-bg': item.index === (activeStep + 1),
                'previous-bg': !(item.index === (activeStep + 1)) && isPreviousStep(item),
                'border-step': !(item.index === (activeStep + 1)) && !isPreviousStep(item)
              }"
            >
              <i
                v-if="isPreviousStep(item)"
                class="fas fa-check"
              />
              <span v-else> {{ item?.index }} </span>
            </span>
            <div class="d-flex align-items-center w-100" style="column-gap: 10px">
              <span> {{ item?.label }} </span>
              <span
                v-if="item?.index < items.length"
                class="border flex-grow-1"
                style="border-color: #0e76a8"
              />
            </div>
          </section>
        </Transition>
      </div>
    </section>

    <form @submit.prevent="nextStep">
      <slot :name="activeStep" />
      <section class="d-flex flex-row justify-content-end mt-3" style="column-gap: 5px">
        <button
          class="btn btn-secondary"
          v-if="activeStep > 0"
          v-on:click="prevStep"
        >
          <i class="mdi mdi-arrow-left" />
          {{ $t("Anterior") }}
        </button>
        <button
          class="btn btn-submit-stepper mr-0"
          data-style="zoom-in"
          type="submit"
          :class="isLast ? 'btn-success' : 'btn-primary'"
        >
          {{ isLast ? $t("Voltar ao início") : $t("Próximo") }}
          <i
            class="mdi"
            :class="isLast ? 'mdi-home' : 'mdi-arrow-right' "
          />
        </button>
      </section>
    </form>
  </main>
</template>

<script>

export default {
  name: "Stepper",
  props: [
    "items",
    "actionNext",
    "actionPrev",
    "isValidToNext",
  ],
  data() {
    return {
      activeStep: 0
    };
  },
  computed: {
    isLast() {
      return this.activeStep === this.items.length - 1
    }
  },
  methods: {
    async nextStep() {
      if (this.activeStep <= (this.items.length - 1)) {

        await this.actionNext(this.activeStep);

        if (this.isLast && this.isValidToNext) return this.activeStep = 0;

        if (this.isValidToNext) this.activeStep++;
      }
    },

    async prevStep() {
      await this.actionPrev(this.activeStep - 1);

      this.activeStep--;
    },

    isPreviousStep(item) {
      return item.index < (this.activeStep + 1);
    },
  }
}
</script>

<style scoped>
.bg-step,
.bg-step-active,
.bg-step-previous {
  transition: background-color 0.2s linear;
}

.step-enter-active,
.step-leave-active {
  transition: opacity 1s ease;
}

.step-enter,
.step-leave-to {
  opacity: 0;
}

.wrapper-class {
  display: flex;
  align-items: center;
  gap: 10px;
}

.step-item {
  display: flex;
  align-items: center;
  text-align: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 100%;
  font-size: 14px;
  justify-content: center;
  color: white;
}

.active-bg {
  background: #5895ff;
}

.previous-bg {
  background: #00c851
}

.border-step {
  border: 1px solid #9399a1;
  color: #9399a1;
}
</style>

